// @flow
import { httpClient } from 'angieslist-app-platform';

export type CreateAndActivateBusinessManagementToolsSubscriptionRequest = {
  serviceProviderId: number,
};

export type CreateAndActivateBusinessManagementToolsSubscriptionResponse = {};

const createAndActivateBusinessManagementToolsSubscription =
  (serviceProviderId: number, oneTimeToken: string): any => {
    const requestBody: CreateAndActivateBusinessManagementToolsSubscriptionRequest = {
      serviceProviderId,
    };

    return httpClient.post('/gateway/advertising/v1/agreement/addon/business-management/create-and-activate', {
      body: requestBody,
      headers: {
        'X-ANGI-CallerId': serviceProviderId,
        Authorization: 'OneTime '.concat(oneTimeToken),
      },
    });
  };

export type GetBusinessManagementToolsAgreementAddOnEligibilityRequest = {
  serviceProviderId: number,
};

export type AddOnPricing = {
  termPrice: number,
  termInMonths: number,
};

export type GetBusinessManagementToolsAgreementAddOnEligibilityResponse = {
  hasEntitlement: boolean,
  isEligible: boolean,
  pricing: ?AddOnPricing,
  addOnEndDate: ?Date,
};

const getBusinessManagementToolsAgreementAddOnEligibility =
  (serviceProviderId: number, oneTimeToken: string): any => {
    const requestBody: GetBusinessManagementToolsAgreementAddOnEligibilityRequest = {
      serviceProviderId,
    };

    return httpClient.post('/gateway/advertising/v1/agreement/addon/business-management/eligibility', {
      body: requestBody,
      headers: {
        'X-ANGI-CallerId': serviceProviderId,
        Authorization: 'OneTime '.concat(oneTimeToken),
      },
    });
  };


export type CancelBusinessManagementToolsSubscriptionRequest = {
  serviceProviderId: number,
};

export type CancelBusinessManagementToolsSubscriptionResponse = {};

const cancelBusinessManagementToolsSubscription = (serviceProviderId: number): any => {
  const body: CancelBusinessManagementToolsSubscriptionRequest = {
    serviceProviderId,
  };

  return httpClient.post(
    '/gateway/advertising/v1/agreement/addon/business-management/cancel',
    {
      body,
    },
  );
};


export default {
  createAndActivateBusinessManagementToolsSubscription,
  getBusinessManagementToolsAgreementAddOnEligibility,
  cancelBusinessManagementToolsSubscription,
};



// WEBPACK FOOTER //
// ./src/app/common/agreementAddOn/agreementAddOnService.js